import { render, staticRenderFns } from "./rankTitle.vue?vue&type=template&id=20865b0a&scoped=true"
import script from "./rankTitle.vue?vue&type=script&lang=js"
export * from "./rankTitle.vue?vue&type=script&lang=js"
import style0 from "./rankTitle.vue?vue&type=style&index=0&id=20865b0a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20865b0a",
  null
  
)

export default component.exports